// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Thankyou_cardWrapper__vtzAl","innerCardWrapper":"Thankyou_innerCardWrapper__MNHdo","btn":"Thankyou_btn__CWgpL","cardBody":"Thankyou_cardBody__qtxcX"};